import RequestFollowUp from "@tuteria/shared-lib/src/admin/RequestFollowUp";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import React from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

type Params = {
  actions: any[];
  nodeId: string;
  requestId: string;
  followupStage: number;
  baseUrl: string;
  callback: (...args: any[]) => void;
};

// declare global {
//   interface Window {
//     $: any;
//   }
// }
const RenderItemInPortal = ({ domNode, component }) => {
  return ReactDOM.createPortal(component, domNode);
};

const RenderAllComponents: React.FC<any> = ({
  components = [],
  nodes = [],
}) => {
  return (
    <>
      {components.map((o: any, i: any) => (
        <RenderItemInPortal key={i} domNode={nodes[i]} component={o} />
      ))}
    </>
  );
};

// export function unMountRequestFollowUp(id: string) {
//   ReactDOM.unmountComponentAtNode(document.getElementById(id));
// }

// export function renderRequestFollowUp({
//   actions,
//   nodeId,
//   requestId,
//   followupStage,
//   baseUrl,
//   callback,
// }: Params) {
//   function onClose() {
//     unMountRequestFollowUp(nodeId);
//   }

//   async function updateRemark(requestId, fields) {
//     const response = await fetch(baseUrl, {
//       body: JSON.stringify({ ...fields, user_id: requestId }),
//       headers: { "content-type": "application/json" },
//       method: "POST",
//     });

//     if (response.ok) {
//       const { data } = await response.json();
//       callback(requestId, fields.action, data.content);
//       onClose();
//     } else {
//       throw new Error(response.statusText);
//     }
//   }

//   async function updateFollowUpStage(requestId, stage) {
//     const response = await fetch(baseUrl, {
//       body: JSON.stringify({
//         followup_stage: stage,
//         user_id: requestId,
//         field: "followup_stage",
//       }),
//       headers: { "content-type": "application/json" },
//       method: "POST",
//     });

//     if (response.ok) {
//       const { data } = await response.json();
//       callback(requestId, "followup_stage", data.followup_stage);
//     } else {
//       throw new Error(response.statusText);
//     }
//   }

//   ReactDOM.render(
//     <ThemeProvider>
//       <RequestFollowUp
//         actions={actions}
//         request_id={requestId}
//         onClose={onClose}
//         currentStage={followupStage}
//         onUpdateRemark={updateRemark}
//         onUpdateStage={updateFollowUpStage}
//       />
//     </ThemeProvider>,
//     document.getElementById(nodeId)
//   );
// }

export function initializeFollowupAdmin({
  actions,
  baseUrl = "",
  selector = "td.field-remarks",
  childNode,
}) {
  async function updateRemark(requestId, fields) {
    const response = await fetch(baseUrl, {
      body: JSON.stringify({ ...fields, user_id: requestId }),
      headers: { "content-type": "application/json" },
      method: "POST",
    });

    if (response.ok) {
      const { data } = await response.json();
      return data;
    } else {
      throw new Error(response.statusText);
    }
  }

  async function updateFollowUpStage(requestId, stage) {
    const response = await fetch(baseUrl, {
      body: JSON.stringify({
        followup_stage: stage,
        user_id: requestId,
        field: "followup_stage",
      }),
      headers: { "content-type": "application/json" },
      method: "POST",
    });

    if (response.ok) {
      const { data } = await response.json();
      return data.content;
    } else {
      throw new Error(response.statusText);
    }
  }

  function deleteRow(requestId) {
    const container = document.getElementById(`remark-${requestId}`);
    const row = container.parentElement.parentElement;
    row.remove();
  }

  let components = [];
  let domNodes = document.querySelectorAll(selector);
  Array.from(domNodes).forEach((node) => {
    let text = node.innerHTML;
    let { requestId, followupStage } = window.$(text).data();
    let nn = (
      <>
        {/* <div dangerouslySetInnerHTML={{ __html: text }} /> */}
        <RequestFollowUp
          content={text}
          actions={actions}
          request_id={requestId}
          currentStage={followupStage}
          onUpdateRemark={updateRemark}
          removeRow={() => {
            deleteRow(requestId);
          }}
          updateRemarkCell={(action, remarks: []) => {
            if (action !== "generic") {
              deleteRow(requestId);
            } else {
              const container = document.getElementById(`remark-${requestId}`);
              const { created, remark, staff } = remarks[remarks.length - 1];
              const formattedDate = formatDateString(created);
              container.innerHTML += `
                <br />
                <p style="margin: 1px 0;"><b>Remark: </b>${remark}</p>
                <p style="margin: 1px 0;"><b>Updated by: </b>${staff}</p>
                <p style="margin: 1px 0;"><b>On: </b> ${formattedDate}</p>
              `;
            }
          }}
          onUpdateStage={updateFollowUpStage}
        />
      </>
    );
    components.push(nn);
  });
  if (childNode) {
    ReactDOM.render(
      <ThemeProvider>
        <RenderAllComponents components={components} nodes={domNodes} />
      </ThemeProvider>,
      childNode
    );
  }
}

function formatDateString(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  // zero indicates the first month of the year
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}/${month}/${day} ${hours}:${minutes}`;
}
